import { Component, Injector, OnInit, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { AuditLog, RoleHistoryChange, RoleHistoryLog } from '../../models/audit-log.model';

interface ChangesByTypeItem {
  roleNameChanged: RoleHistoryChange[];
  permissionsAdded: RoleHistoryChange[];
  permissionsRemoved: RoleHistoryChange[];
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly translate = inject(TranslateService);
  private injector = inject(Injector);
  public title: string;
  public historyHeader: string;
  public historyHeaders: string;
  public historyType: string;
  public action: string;
  public auditLogs: AuditLog[] | RoleHistoryLog[];
  public auditLogs$: Observable<AuditLog[]>;
  public dateTimeDisplay = environment.dateTimeDisplay;
  public changesFormat: 'changes' | undefined = undefined;

  public auditLogsFrom$!: Signal<AuditLog[]>;
  readonly resolvedAuditLogs = computed(() => this.auditLogs ?? this.auditLogsFrom$() ?? []);

  readonly changesByType = computed<ChangesByTypeItem[]>(() => {
    const logs = this.resolvedAuditLogs();
    if (!this.changesFormat) return [];

    return logs.map(log => {
      const changes = (log as RoleHistoryLog).changes ?? [];
      return {
        roleNameChanged: changes.filter(c => c.type === 'ROLE_NAME_CHANGED'),
        permissionsAdded: changes.filter(c => c.type === 'PERMISSIONS_ADDED'),
        permissionsRemoved: changes.filter(c => c.type === 'PERMISSIONS_REMOVED')
      };
    });
  });

  ngOnInit() {
    this.auditLogsFrom$ = toSignal(this.auditLogs$ ?? of([]), {
      initialValue: [] as AuditLog[],
      injector: this.injector
    });
  }

  decline(): void {
    this.bsModalRef.hide();
  }

  getActivityLabel(activity: string): string {
    const key = 'HISTORY_ACTIVITY.' + activity;
    const translated = this.translate.instant(key);
    return translated === key ? activity : translated;
  }
}
